import { Box } from "@mui/material";
import styled from "styled-components";

export const BookedAppointmentStyled = styled(Box)`
  svg {
    width: 100%;
    height: auto;
  }
  .btn-wrapper {
    display: flex;
    justify-content: center;
    column-gap: 16px;
    margin-top: 16px;
  }
`;
